export default {
  install(Vue) {
    // singleton instantiation
    window.adacado = window.adacado || {}
    window.adacado.guiBus = window.adacado.guiBus || new Vue()

    const guiBus = window.adacado.guiBus

    // create listener for event
    Vue.prototype.guibus_subscribe = function(event, fn) {
      guiBus.$on(event, fn)
    }

    // announce event occurrence with any data for that occurrence
    Vue.prototype.guibus_publish = function(event, payload) {
      guiBus.$emit(event, payload)
    }

    // remove listener
    Vue.prototype.guibus_unsubscribe = function(event, fn) {
      guiBus.$off(event, fn)
    }
  },
}
